<template>
  <div id="app" class="app">
    <!--    <transition name="fade" mode="in-out">-->
       <router-view></router-view>
    <!--    </transition>-->
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {},
    created() {

    },
    watch: {
      $route(to) {
        console.log(document.body.clientWidth, to)
      }
    },
  }
</script>

<style>
  html, body {
    height: 100%;
    margin: 0;
  }
</style>

<style lang="less" scoped>
  #app {
    height: 100%;
    width: 100%;
    background: #fff;
    position: relative;
    overflow-x: hidden;
  }
 

  .fade-enter {
    opacity: 0;
  }

  .fade-leave {
    opacity: 1;
  }

  .fade-enter-active {

    transition: opacity .5s;

  }

  .fade-leave-active {
    opacity: 0;
    transition: opacity .1s;
  }

  .fade-leave-to {
    display: none;
  }

 
</style>
